/**
 * gatsby-browser.js
 *
 * Dostępność: domyślny route-announcer Gatsby (#gatsby-announcer) ma
 * aria-live="assertive", co przerywa czytnik ekranu przy każdej zmianie
 * trasy. Zmiana trasy to aktualizacja statusu, nie komunikat krytyczny —
 * przełączamy na aria-live="polite" (WCAG 4.1.3 Status Messages).
 */

const setPoliteAnnouncer = () => {
  const announcer = document.getElementById("gatsby-announcer")
  if (announcer && announcer.getAttribute("aria-live") !== "polite") {
    announcer.setAttribute("aria-live", "polite")
  }
}

export const onInitialClientRender = () => {
  setPoliteAnnouncer()
}

export const onRouteUpdate = () => {
  setPoliteAnnouncer()
}
